import { Blogger, CopyLink, Douban, Email, Facebook, Instagram, Line, Messenger, Odnoklassniki, Pinterest, Qq, Qzone, Renren, Rss, Signal, Telegram, Tqq, Twitter, Viber, Vkontakte, Wechat, Weibo, Whatsapp, Youku, Youtube } from '@ori-ui/icons';
import { MessengerGradient } from './MessengerGradient';
import { TelegramGradient } from './TelegramGradient';
import { jsx as _jsx } from "react/jsx-runtime";
export const iconsMapping = {
  blogger: {
    icon: Blogger
  },
  douban: {
    icon: Douban
  },
  email: {
    icon: Email
  },
  facebook: {
    icon: Facebook
  },
  instagram: {
    icon: Instagram
  },
  line: {
    icon: Line
  },
  link: {
    icon: CopyLink
  },
  messenger: {
    icon: Messenger,
    multicolor: /*#__PURE__*/_jsx(MessengerGradient, {})
  },
  odnoklassniki: {
    icon: Odnoklassniki
  },
  pinterest: {
    icon: Pinterest
  },
  qq: {
    icon: Qq
  },
  qzone: {
    icon: Qzone
  },
  renren: {
    icon: Renren
  },
  rss: {
    icon: Rss
  },
  signal: {
    icon: Signal
  },
  telegram: {
    icon: Telegram,
    multicolor: /*#__PURE__*/_jsx(TelegramGradient, {})
  },
  tqq: {
    icon: Tqq
  },
  twitter: {
    icon: Twitter
  },
  viber: {
    icon: Viber
  },
  vkontakte: {
    icon: Vkontakte
  },
  wechat: {
    icon: Wechat
  },
  weibo: {
    icon: Weibo
  },
  whatsapp: {
    icon: Whatsapp
  },
  youku: {
    icon: Youku
  },
  youtube: {
    icon: Youtube
  }
};
//# sourceMappingURL=iconsMapping.js.map